export default "__VITE_ASSET__B3EvS6GP__"